import React, { useState } from "react";
import { notification } from "antd";
import styled from "styled-components";
import API_URL from "../../config";

const axios = require("axios").default;

const COLORS = [
  "#ae094d","#1890ff","#52c41a","#faad14","#722ed1",
  "#13c2c2","#eb2f96","#fa541c","#a0d911","#2f54eb",
  "#f5222d","#fa8c16","#a8071a","#0050b3","#237804",
];

/* ── SVG pasta yardımcıları ── */
function polar(cx, cy, r, deg) {
  const rad = ((deg - 90) * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}
function arcPath(cx, cy, r, start, end) {
  const s = polar(cx, cy, r, start);
  const e = polar(cx, cy, r, end);
  const large = end - start > 180 ? 1 : 0;
  return `M ${cx} ${cy} L ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y} Z`;
}
function buildSlices(items) {
  const total = items.reduce((s, i) => s + i.value, 0);
  let angle = 0;
  return items.map((item) => {
    const sweep = (item.value / total) * 360;
    const slice = { ...item, start: angle, end: angle + sweep, total };
    angle += sweep;
    return slice;
  });
}

/* ── Styled ── */
const PageWrap = styled.div` padding: 24px; `;
const FilterRow = styled.div`
  display: flex; align-items: flex-end; gap: 12px; margin-bottom: 24px; flex-wrap: wrap;
`;
const Label = styled.label` font-size: 13px; font-weight: 500; color: #555; `;
const DateInput = styled.input`
  border: 1px solid #d9d9d9; border-radius: 6px; padding: 6px 10px; font-size: 14px; outline: none;
  &:focus { border-color: #ae094d; }
`;
const SearchButton = styled.button`
  background: #ae094d; color: #fff; border: none; border-radius: 6px;
  padding: 7px 20px; font-size: 14px; cursor: pointer;
  &:hover { background: #8e0040; }
  &:disabled { background: #ccc; cursor: not-allowed; }
`;
const SummaryRow = styled.div` display: flex; gap: 16px; margin-bottom: 28px; flex-wrap: wrap; `;
const SummaryCard = styled.div`
  background: #fff; border: 1px solid #f0f0f0; border-radius: 8px;
  padding: 14px 28px; text-align: center; min-width: 160px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  .value { font-size: 28px; font-weight: 700; color: ${(p) => p.color || "#ae094d"}; }
  .title { font-size: 12px; color: #888; margin-top: 4px; }
`;
const Section = styled.div` margin-bottom: 32px; `;
const SectionTitle = styled.div`
  font-size: 15px; font-weight: 600; color: #333;
  margin-bottom: 12px; padding-bottom: 6px; border-bottom: 2px solid #f0f0f0;
`;
const Divider = styled.div` border-top: 3px dashed #f0f0f0; margin: 40px 0; `;

/* abonelik türleri çubuk */
const TypeList = styled.div` display: flex; flex-direction: column; gap: 10px; `;
const TypeRow = styled.div` display: flex; align-items: center; gap: 12px; `;
const TypeLabel = styled.div` min-width: 200px; font-size: 13px; color: #444; `;
const TypeBarOuter = styled.div`
  flex: 1; height: 22px; background: #f5f5f5; border-radius: 4px; overflow: hidden;
`;
const TypeBarInner = styled.div`
  height: 100%; width: ${(p) => p.pct}%; background: #ae094d;
  border-radius: 4px; transition: width 0.5s ease;
  min-width: ${(p) => (p.pct > 0 ? "4px" : "0")};
`;
const TypeCount = styled.div`
  min-width: 40px; text-align: right; font-size: 13px; font-weight: 600; color: #ae094d;
`;

/* dikey çubuk */
const VerticalBarsArea = styled.div`
  display: flex; align-items: flex-end; gap: 16px;
  height: 240px; overflow-x: auto; padding-bottom: 4px;
`;
const VBarGroup = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 6px; min-width: 64px;
`;
const VBarOuter = styled.div`
  width: 48px; height: 180px; display: flex; align-items: flex-end;
  background: #f5f5f5; border-radius: 6px 6px 0 0; overflow: hidden;
`;
const VBarInner = styled.div`
  width: 100%; height: ${(p) => p.pct}%;
  background: ${(p) => (p.active ? "#1890ff" : "#ff4d4f")};
  border-radius: 6px 6px 0 0; transition: height 0.5s ease;
  display: flex; align-items: flex-start; justify-content: center;
`;
const VBarValue = styled.span` font-size: 11px; font-weight: 700; color: #fff; margin-top: 5px; `;
const VBarLabel = styled.div`
  font-size: 11px; color: #555; text-align: center; word-break: break-all; max-width: 64px;
`;
const VBarPct = styled.div` font-size: 10px; color: #aaa; `;

/* pasta + gelir yan yana */
const PieAndRevenue = styled.div`
  display: flex; gap: 40px; flex-wrap: wrap; margin-top: 24px; align-items: flex-start;
`;
const PieWrap = styled.div`
  display: flex; align-items: flex-start; gap: 32px; flex-wrap: wrap;
`;
const RevenueWrap = styled.div`
  flex: 1; min-width: 260px;
`;
const RevenueTitle = styled.div`
  font-size: 13px; font-weight: 600; color: #333; margin-bottom: 14px;
`;
const RevBarsArea = styled.div`
  display: flex; align-items: flex-end; gap: 12px; height: 220px; overflow-x: auto;
`;
const RevBarGroup = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 5px; min-width: 70px;
`;
const RevBarOuter = styled.div`
  width: 50px; height: 180px; display: flex; align-items: flex-end;
  background: #f5f5f5; border-radius: 6px 6px 0 0; overflow: hidden;
`;
const RevBarInner = styled.div`
  width: 100%; height: ${(p) => p.pct}%; background: #52c41a;
  border-radius: 6px 6px 0 0; transition: height 0.5s ease;
  display: flex; align-items: flex-start; justify-content: center;
`;
const RevBarValue = styled.span`
  font-size: 10px; font-weight: 700; color: #fff; margin-top: 4px; text-align: center; padding: 0 2px;
`;
const RevBarLabel = styled.div`
  font-size: 10px; color: #555; text-align: center; max-width: 70px;
`;
const RevBarTL = styled.div`
  font-size: 10px; color: #52c41a; font-weight: 600;
`;
const LegendList = styled.div` display: flex; flex-direction: column; gap: 8px; `;
const LegendItem = styled.div` display: flex; align-items: center; gap: 8px; font-size: 13px; color: #444; `;
const LegendDot = styled.div`
  width: 12px; height: 12px; border-radius: 50%; background: ${(p) => p.color}; flex-shrink: 0;
`;

/* ── Generic pasta grafik ── */
const SvgPie = ({ items }) => {
  if (!items || items.length === 0) return null;
  const slices = buildSlices(items);
  const cx = 110, cy = 110, r = 100;
  return (
    <PieWrap>
      <svg width={220} height={220} style={{ flexShrink: 0 }}>
        {slices.map((s, i) => (
          <path
            key={i}
            d={arcPath(cx, cy, r, s.start, s.end)}
            fill={s.color}
            stroke="#fff"
            strokeWidth={2}
          />
        ))}
      </svg>
      <LegendList>
        {slices.map((s, i) => (
          <LegendItem key={i}>
            <LegendDot color={s.color} />
            <span style={{ minWidth: 160 }}>{s.name}</span>
            <span style={{ fontWeight: 600 }}>{s.value}</span>
            <span style={{ color: "#aaa", marginLeft: 4 }}>
              %{Math.round((s.value / s.total) * 100)}
            </span>
          </LegendItem>
        ))}
      </LegendList>
    </PieWrap>
  );
};

/* ── Abonelik türleri pasta ── */
const TypePieChart = ({ byType }) => {
  const items = [...byType]
    .sort((a, b) => b.count - a.count)
    .map((r, i) => ({
      name: `${r.monthly} mo — ${r.days} days/wk`,
      value: r.count,
      color: COLORS[i % COLORS.length],
    }));
  return <SvgPie items={items} />;
};

/* ── İndirim kodu pasta (8 altı → Diğer) ── */
const DiscountPieChart = ({ byDiscount }) => {
  const main = byDiscount.filter((r) => r.count >= 8);
  const otherCount = byDiscount.filter((r) => r.count < 8).reduce((s, r) => s + r.count, 0);
  const items = main.map((r, i) => ({
    name: r.code,
    value: r.count,
    color: COLORS[i % COLORS.length],
  }));
  if (otherCount > 0) items.push({ name: "Other", value: otherCount, color: "#bfbfbf" });
  return <SvgPie items={items} />;
};

/* ─────────── */

const SubscriptionReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    if (!startDate || !endDate) {
      notification.warning({ message: "Please enter start and end dates." });
      return;
    }
    if (startDate > endDate) {
      notification.warning({ message: "Start date cannot be after the end date." });
      return;
    }
    setLoading(true);
    setData(null);
    try {
      const res = await axios.get(`${API_URL}subscription-report/report`, {
        params: { startDate, endDate },
        withCredentials: true,
      });
      setData(res.data);
    } catch (err) {
      notification.error({ message: "Failed to load report." });
    } finally {
      setLoading(false);
    }
  };

  const maxTypeCount = data?.byType?.length
    ? Math.max(...data.byType.map((r) => r.count)) : 1;
  const maxDiscountCount = data?.byDiscount?.length
    ? Math.max(...data.byDiscount.map((r) => r.count)) : 1;

  return (
    <PageWrap>
      <h2 style={{ marginBottom: 20 }}>Subscription report</h2>

      <FilterRow>
        <div>
          <Label>Start date</Label><br />
          <DateInput type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </div>
        <div>
          <Label>End date</Label><br />
          <DateInput type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>
        <SearchButton onClick={fetchReport} disabled={loading}>
          {loading ? "Loading..." : "Run report"}
        </SearchButton>
      </FilterRow>

      {data && (
        <>
          <SummaryRow>
            <SummaryCard>
              <div className="value">{data.total}</div>
              <div className="title">Member count</div>
            </SummaryCard>
            <SummaryCard color="#52c41a">
              <div className="value">{data.paid}</div>
              <div className="title">Subscriptions</div>
            </SummaryCard>
          </SummaryRow>

          <Section>
            <SectionTitle>By subscription type</SectionTitle>
            <TypeList>
              {[...data.byType].sort((a, b) => b.count - a.count).map((row, i) => (
                <TypeRow key={i}>
                  <TypeLabel>{row.monthly} mo — {row.days} days/wk</TypeLabel>
                  <TypeBarOuter>
                    <TypeBarInner pct={Math.round((row.count / maxTypeCount) * 100)} />
                  </TypeBarOuter>
                  <TypeCount>{row.count}</TypeCount>
                </TypeRow>
              ))}
              {data.byType.length === 0 && (
                <div style={{ color: "#aaa", fontSize: 13 }}>No data for this date range.</div>
              )}
            </TypeList>
            {data.byType.length > 0 && (
              <PieAndRevenue>
                <TypePieChart byType={data.byType} />
                {data.byRevenue && data.byRevenue.length > 0 && (() => {
                  const maxTL = Math.max(...data.byRevenue.map((r) => r.total_tl));
                  return (
                    <RevenueWrap>
                      <RevenueTitle>Top packages by revenue (TRY)</RevenueTitle>
                      <RevBarsArea>
                        {data.byRevenue.map((row, i) => {
                          const pct = Math.round((row.total_tl / maxTL) * 100);
                          return (
                            <RevBarGroup key={i}>
                              <RevBarOuter>
                                <RevBarInner pct={pct}>
                                  {pct >= 15 && <RevBarValue>{row.count}</RevBarValue>}
                                </RevBarInner>
                              </RevBarOuter>
                              <RevBarLabel>{row.monthly} mo / {row.days} d/wk</RevBarLabel>
                              <RevBarTL>{Number(row.total_tl).toLocaleString("tr-TR")} ₺</RevBarTL>
                            </RevBarGroup>
                          );
                        })}
                      </RevBarsArea>
                    </RevenueWrap>
                  );
                })()}
              </PieAndRevenue>
            )}
          </Section>

          <Divider />

          <Section>
            <SectionTitle>Discount code usage</SectionTitle>
            {data.byDiscount.length === 0 ? (
              <div style={{ color: "#aaa", fontSize: 13 }}>No discount code usage in this range.</div>
            ) : (
              <>
                <VerticalBarsArea>
                  {data.byDiscount.map((row, i) => {
                    const pct = Math.round((row.count / maxDiscountCount) * 100);
                    const now = new Date();
                    const isActive = row.start && row.finish
                      ? new Date(row.start) <= now && new Date(row.finish) >= now
                      : false;
                    return (
                      <VBarGroup key={i}>
                        <VBarOuter>
                          <VBarInner pct={pct} active={isActive}>
                            {pct >= 12 && <VBarValue>{row.count}</VBarValue>}
                          </VBarInner>
                        </VBarOuter>
                        <VBarLabel>{row.code}</VBarLabel>
                        <VBarPct>{row.count}</VBarPct>
                      </VBarGroup>
                    );
                  })}
                </VerticalBarsArea>
                <PieAndRevenue>
                  <DiscountPieChart byDiscount={data.byDiscount} />
                  {data.byDiscountRevenue && data.byDiscountRevenue.length > 0 && (() => {
                    const maxTL = Math.max(...data.byDiscountRevenue.map((r) => r.total_tl));
                    return (
                      <RevenueWrap>
                        <RevenueTitle>Top discount codes by revenue (TRY)</RevenueTitle>
                        <RevBarsArea>
                          {data.byDiscountRevenue.map((row, i) => {
                            const pct = Math.round((row.total_tl / maxTL) * 100);
                            return (
                              <RevBarGroup key={i}>
                                <RevBarOuter>
                                  <RevBarInner pct={pct}>
                                    {pct >= 15 && <RevBarValue>{row.count}</RevBarValue>}
                                  </RevBarInner>
                                </RevBarOuter>
                                <RevBarLabel>{row.code}</RevBarLabel>
                                <RevBarTL>{Number(row.total_tl).toLocaleString("tr-TR")} ₺</RevBarTL>
                              </RevBarGroup>
                            );
                          })}
                        </RevBarsArea>
                      </RevenueWrap>
                    );
                  })()}
                </PieAndRevenue>
              </>
            )}
          </Section>
        </>
      )}
    </PageWrap>
  );
};

export default SubscriptionReport;
